import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo2 from "../../assets/img/favicon-v4.png";
import actions from "../../../redux/user/actions.js";
import { usePermission } from "../../../hooks/usePermission";

const NAV_GROUPS = [
  {
    label: "Users",
    module: "user",
    items: [
      { label: "Users", path: "/admin/user", module: "user" },
      { label: "EDD", path: "/admin/edd", module: "user" },
      { label: "Alert Users", path: "/admin/alert", module: "user" },
    ],
  },
  {
    label: "Trading",
    module: "coin",
    items: [
      { label: "Coins", path: "/admin/coin", module: "coin" },
      { label: "Currency", path: "/admin/currency", module: "currency" },
      { label: "Trading Pairs", path: "/admin/tradingPair", module: "trading-pair" },
      { label: "P2P Support Coins", path: "/admin/p2p", module: "p2p-support-coin" },
      { label: "Payment Methods", path: "/admin/payment", module: "payment-method" },
    ],
  },
  {
    label: "Finance",
    module: "order",
    items: [
      { label: "Orders", path: "/admin/order", module: "order" },
      { label: "Wallets", path: "/admin/wallet", module: "wallet" },
      { label: "Withdrawals", path: "/admin/withdrawal", module: "coin-buy-sell" },
      { label: "Deposits", path: "/admin/deposit", module: "coin-buy-sell" },
      { label: "Held Transactions", path: "/admin/wallet-review", module: "wallet-tx-review" },
      { label: "Bulk Trade Requests", path: "/admin/bulk-trade-request", module: "bulk-trade-request" },
    ],
  },
  {
    label: "Finance Dashboard",
    module: "finance-overview",
    items: [
      { label: "Fee & Revenue Analytics", path: "/admin/finance/overview", module: "finance-overview" },
      { label: "Withdrawal Fees", path: "/admin/finance/withdrawal-fees", module: "finance-withdrawal-fees" },
      { label: "TDS Reports", path: "/admin/finance/tds", module: "finance-tds" },
      { label: "INR Deposit", path: "/admin/finance/inr-deposits", module: "finance-inr-deposit" },
      { label: "INR Withdraw", path: "/admin/finance/inr-withdrawals", module: "finance-inr-withdraw" },
      { label: "Funding Wallet Transactions", path: "/admin/finance/funding-wallet-transactions", module: "finance-funding-wallet-tx" },
      { label: "FIU Reports", path: "/admin/finance/fiu-reports", module: "finance-fiu-reports" },
    ],
  },
  {
    label: "Network",
    module: "coin-network",
    items: [
      { label: "Coin Networks", path: "/admin/network", module: "coin-network" },
      { label: "Fireblocks Sync", path: "/admin/fireblocks-sync", module: "fireblocks-config" },
    ],
  },
  {
    label: "Compliance",
    module: "compliance-config",
    items: [
      { label: "Compliance Config", path: "/admin/compliance", module: "compliance-config" },
      // { label: "Gullak Plans", path: "/admin/gullak-plans", module: "dashboard" },
    ],
  },
  {
    label: "Reports",
    module: "user",
    items: [
      { label: "Third Party Stats", path: "/admin/third-party-stats", module: "user" },
      { label: "Balance Comparison", path: "/admin/balance-comparison", module: "wallet" },
      { label: "Exchange Trades", path: "/admin/coindcx-orders", module: "order-transaction" },
    ],
  },
  {
    label: "Content",
    module: "home-faq",
    items: [
      { label: "FAQs", path: "/admin/faq", module: "home-faq" },
      { label: "Newsletter", path: "/admin/newsletter", module: "news-letter" },
      { label: "Contact Us", path: "/admin/contact-us", module: "contact-us" },
      { label: "Support", path: "/admin/support", module: "support" },
      { label: "Policy Links", path: "/admin/policy-link", module: "policy-link" },
    ],
  },
  {
    label: "Admin",
    module: "role",
    items: [
      { label: "Admin Users", path: "/admin/admin-users", module: "role" },
      { label: "Roles", path: "/admin/roles", module: "role" },
    ],
  },
//   {
//     label: "Affiliates",
//     module: "affiliate",
//     items: [
//       { label: "Affiliate Codes", path: "/admin/affiliate", module: "affiliate" },
//     ],
//   },
  // {
  //   label: "KYC Configuration",
  //   module: "kyc-config",
  //   items: [
  //     { label: "KYC Configuration", path: "/admin/kyc-config", module: "kyc-config" },
  //   ],
  // },
  {
    label: "Activity",
    module: "logs",
    items: [
      { label: "Logs", path: "/admin/logs", module: "logs" },
    ],
  },
  {
    label: "System",
    module: "maintenance",
    items: [
      { label: "Maintenance Mode",             path: "/admin/maintenance",    module: "maintenance" },
      { label: "Deposit / Withdrawal Controls", path: "/admin/feature-toggle", module: "feature-toggle" },
    ],
  },
];

const NavDropdown = ({ group, isActive, onClose }) => {
  const location = useLocation();
  return (
    <div className="topnav__dropdown">
      {group.items.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`topnav__dropdown-item${location.pathname === item.path || location.pathname.startsWith(item.path + "/") ? " topnav__dropdown-item--active" : ""}`}
          onClick={onClose}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

const Header = (props) => {
  const navigate = useHistory();
  const location = useLocation();
  const { user, loggedIn } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { canView, isSuperAdmin } = usePermission();

  const [openGroup, setOpenGroup] = useState(null);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navRef = useRef(null);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenGroup(null);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logOut = () => {
    setUserMenuOpen(false);
    dispatch(actions.setUser(null));
    dispatch(actions.setLoggedIn(false));
    dispatch(actions.setToken(null));
    dispatch(actions.setRole(null));
    dispatch(actions.setPermission([]));
    dispatch(actions.setSidebarItems([]));
    localStorage.clear();
    setTimeout(() => navigate.push("/admin/login"), 1500);
  };

  const exclusionPaths = ["/admin/login", "/admin/forgotPassword", "/"];
  if (exclusionPaths.includes(props.location.pathname) || !loggedIn) {
    return null;
  }

  const isGroupActive = (group) =>
    group.items.some(
      (item) =>
        location.pathname === item.path ||
        location.pathname.startsWith(item.path + "/")
    );

  const visibleGroups = NAV_GROUPS.filter((group) =>
    isSuperAdmin || group.items.some((item) => canView(item.module))
  );

  const toggleGroup = (label) => {
    setOpenGroup((prev) => (prev === label ? null : label));
    setUserMenuOpen(false);
  };

  return (
    <nav className="topnav">
      {/* Logo */}
      <Link to="/admin" className="topnav__logo" onClick={() => setOpenGroup(null)}>
        <img src={logo2} alt="Paraa" draggable="false" onContextMenu={(e) => e.preventDefault()} />
      </Link>

      {/* Dashboard direct link */}
      <div className="topnav__menu" ref={navRef}>
        <Link
          to="/admin"
          className={`topnav__direct${location.pathname === "/admin" ? " topnav__direct--active" : ""}`}
          onClick={() => setOpenGroup(null)}
        >
          Dashboard
        </Link>

        {/* Grouped dropdowns */}
        {visibleGroups.map((group) => (
          <div key={group.label} className="topnav__item">
            <button
              className={`topnav__trigger${isGroupActive(group) ? " topnav__trigger--active" : ""}${openGroup === group.label ? " topnav__trigger--open" : ""}`}
              onClick={() => toggleGroup(group.label)}
              type="button"
            >
              {group.label}
              <span className="topnav__caret">▾</span>
            </button>
            {openGroup === group.label && (
              <NavDropdown
                group={group}
                isActive={isGroupActive(group)}
                onClose={() => setOpenGroup(null)}
              />
            )}
          </div>
        ))}
      </div>

      {/* User menu */}
      <div className="topnav__user" ref={userMenuRef}>
        <button
          className="topnav__avatar"
          onClick={() => { setUserMenuOpen((v) => !v); setOpenGroup(null); }}
          type="button"
        >
          {!user?.profileImage ? (
            <span className="topnav__avatar-circle">{user?.name?.charAt(0)}</span>
          ) : (
            <img
              className="topnav__avatar-img"
              src={user?.profileImage}
              width={32}
              height={32}
              alt={user?.name}
              draggable="false"
              onContextMenu={(e) => e.preventDefault()}
            />
          )}
        </button>
        {userMenuOpen && (
          <div className="topnav__user-dropdown">
            <div className="topnav__user-header">
              <span>{user?.name}</span>
            </div>
            <Link
              className="topnav__user-item"
              to="/admin/user-profile"
              onClick={() => setUserMenuOpen(false)}
            >
              My Profile
            </Link>
            <button className="topnav__user-item topnav__user-item--logout" onClick={logOut} type="button">
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
